/**
 * SLAY Fashion Store - Custom Search Dictionary & Dynamic Matching Engine
 */
(function() {
  'use strict';

  var dictionary = {
    // ── GENERAL SHIRT SEARCHES ─────────────────────────────────────────
    "shirts": [
      "Cotton shirts",
      "Linen shirts",
      "Satin shirts",
      "Oxford shirts",
      "Knit shirts",
      "Printed shirts",
      "Textured shirts",
      "Striped shirts",
      "Check shirts",
      "Crinkled shirts",
      "Regular fit shirts",
      "Slim fit shirts",
      "Full sleeve shirts",
      "Half sleeve shirts",
      "Cuban collar shirts"
    ],
    "shirt": [
      "Cotton shirts",
      "Linen shirts",
      "Satin shirts",
      "Oxford shirts",
      "Knit shirts",
      "Printed shirts",
      "Textured shirts",
      "Striped shirts",
      "Check shirts",
      "Crinkled shirts",
      "Regular fit shirts",
      "Slim fit shirts",
      "Full sleeve shirts",
      "Half sleeve shirts",
      "Cuban collar shirts"
    ],
    // ── POCKET & UTILITY SEARCHES ──────────────────────────────────────
    "pocket": [
      "Pocket shirts",
      "Chest pocket shirts",
      "Single pocket shirts",
      "One pocket shirts",
      "Double pocket shirts",
      "Two pocket shirts",
      "Dual pocket shirts",
      "Utility pocket shirts",
      "Cotton pocket shirts",
      "Linen pocket shirts"
    ],
    "pocket shirts": [
      "Pocket shirts",
      "Chest pocket shirts",
      "Single pocket shirts",
      "One pocket shirts",
      "Double pocket shirts",
      "Two pocket shirts",
      "Dual pocket shirts",
      "Utility pocket shirts",
      "Cotton pocket shirts",
      "Linen pocket shirts"
    ],
    "chest pocket": [
      "Chest pocket shirts",
      "Single pocket shirts",
      "Double pocket shirts",
      "Cotton pocket shirts",
      "Linen pocket shirts",
      "Single pocket cotton shirts",
      "Single pocket Oxford shirts",
      "Utility pocket shirts"
    ],
    "chest pocket shirts": [
      "Chest pocket shirts",
      "Single pocket shirts",
      "Double pocket shirts",
      "Cotton pocket shirts",
      "Linen pocket shirts",
      "Single pocket cotton shirts",
      "Single pocket Oxford shirts",
      "Utility pocket shirts"
    ],
    "single pocket": [
      "Single pocket shirts",
      "One pocket shirts",
      "Single pocket cotton shirts",
      "Single pocket linen shirts",
      "Single pocket Oxford shirts",
      "Single pocket printed shirts",
      "Single pocket striped shirts",
      "Single pocket solid shirts",
      "Single pocket full sleeve shirts",
      "Single pocket half sleeve shirts"
    ],
    "single pocket shirts": [
      "Single pocket shirts",
      "One pocket shirts",
      "Single pocket cotton shirts",
      "Single pocket linen shirts",
      "Single pocket Oxford shirts",
      "Single pocket printed shirts",
      "Single pocket striped shirts",
      "Single pocket solid shirts",
      "Single pocket full sleeve shirts",
      "Single pocket half sleeve shirts"
    ],
    "one pocket": [
      "One pocket shirts",
      "Single pocket shirts",
      "Single pocket cotton shirts",
      "Single pocket linen shirts",
      "Single pocket Oxford shirts",
      "Single pocket printed shirts",
      "Single pocket striped shirts",
      "Single pocket solid shirts",
      "Single pocket full sleeve shirts",
      "Single pocket half sleeve shirts"
    ],
    "one pocket shirts": [
      "One pocket shirts",
      "Single pocket shirts",
      "Single pocket cotton shirts",
      "Single pocket linen shirts",
      "Single pocket Oxford shirts",
      "Single pocket printed shirts",
      "Single pocket striped shirts",
      "Single pocket solid shirts",
      "Single pocket full sleeve shirts",
      "Single pocket half sleeve shirts"
    ],
    "double pocket": [
      "Double pocket shirts",
      "Two pocket shirts",
      "Dual pocket shirts",
      "Utility pocket shirts",
      "Utility shirts",
      "Cotton utility shirts",
      "Textured utility shirts",
      "Striped utility shirts"
    ],
    "double pocket shirts": [
      "Double pocket shirts",
      "Two pocket shirts",
      "Dual pocket shirts",
      "Utility pocket shirts",
      "Utility shirts",
      "Cotton utility shirts",
      "Textured utility shirts",
      "Striped utility shirts"
    ],
    "two pocket": [
      "Two pocket shirts",
      "Double pocket shirts",
      "Dual pocket shirts",
      "Utility pocket shirts",
      "Utility shirts",
      "Cotton utility shirts",
      "Textured utility shirts",
      "Striped utility shirts"
    ],
    "two pocket shirts": [
      "Two pocket shirts",
      "Double pocket shirts",
      "Dual pocket shirts",
      "Utility pocket shirts",
      "Utility shirts",
      "Cotton utility shirts",
      "Textured utility shirts",
      "Striped utility shirts"
    ],
    "dual pocket": [
      "Dual pocket shirts",
      "Double pocket shirts",
      "Two pocket shirts",
      "Utility pocket shirts",
      "Utility shirts",
      "Cotton utility shirts"
    ],
    "dual pocket shirts": [
      "Dual pocket shirts",
      "Double pocket shirts",
      "Two pocket shirts",
      "Utility pocket shirts",
      "Utility shirts",
      "Cotton utility shirts"
    ],
    "utility": [
      "Utility shirts",
      "Utility pocket shirts",
      "Cotton utility shirts",
      "Textured utility shirts",
      "Striped utility shirts",
      "Seersucker utility shirts",
      "Short sleeve utility shirts",
      "Double pocket shirts"
    ],
    "utility shirts": [
      "Utility shirts",
      "Utility pocket shirts",
      "Cotton utility shirts",
      "Textured utility shirts",
      "Striped utility shirts",
      "Seersucker utility shirts",
      "Short sleeve utility shirts",
      "Double pocket shirts"
    ],
    "utility pocket": [
      "Utility pocket shirts",
      "Utility shirts",
      "Cotton utility shirts",
      "Textured utility shirts",
      "Striped utility shirts",
      "Seersucker utility shirts",
      "Short sleeve utility shirts",
      "Double pocket shirts"
    ],
    "utility pocket shirts": [
      "Utility pocket shirts",
      "Utility shirts",
      "Cotton utility shirts",
      "Textured utility shirts",
      "Striped utility shirts",
      "Seersucker utility shirts",
      "Short sleeve utility shirts",
      "Double pocket shirts"
    ],
    "cotton utility": [
      "Cotton utility shirts",
      "Utility pocket shirts",
      "Textured utility shirts",
      "Striped utility shirts",
      "Seersucker utility shirts",
      "Short sleeve utility shirts"
    ],
    "cotton utility shirts": [
      "Cotton utility shirts",
      "Utility pocket shirts",
      "Textured utility shirts",
      "Striped utility shirts",
      "Seersucker utility shirts",
      "Short sleeve utility shirts"
    ],
    "textured utility": [
      "Textured utility shirts",
      "Cotton utility shirts",
      "Utility pocket shirts",
      "Striped utility shirts",
      "Seersucker utility shirts",
      "Short sleeve utility shirts"
    ],
    "textured utility shirts": [
      "Textured utility shirts",
      "Cotton utility shirts",
      "Utility pocket shirts",
      "Striped utility shirts",
      "Seersucker utility shirts",
      "Short sleeve utility shirts"
    ],
    "striped utility": [
      "Striped utility shirts",
      "Cotton utility shirts",
      "Textured utility shirts",
      "Utility pocket shirts",
      "Seersucker utility shirts",
      "Short sleeve utility shirts"
    ],
    "striped utility shirts": [
      "Striped utility shirts",
      "Cotton utility shirts",
      "Textured utility shirts",
      "Utility pocket shirts",
      "Seersucker utility shirts",
      "Short sleeve utility shirts"
    ],
    "seersucker utility": [
      "Seersucker utility shirts",
      "Cotton utility shirts",
      "Textured utility shirts",
      "Striped utility shirts",
      "Short sleeve utility shirts"
    ],
    "seersucker utility shirts": [
      "Seersucker utility shirts",
      "Cotton utility shirts",
      "Textured utility shirts",
      "Striped utility shirts",
      "Short sleeve utility shirts"
    ],
    // ── CORE FABRIC SEARCHES ──────────────────────────────────────────
    "cotton": [
      "Cotton shirts",
      "100% cotton shirts",
      "Cotton linen shirts",
      "Cotton printed shirts",
      "Cotton Oxford shirts",
      "Cotton knit shirts",
      "Cotton satin shirts",
      "Cotton textured shirts",
      "Cotton striped shirts",
      "Cotton check shirts"
    ],
    "pure cotton": [
      "Pure cotton shirts",
      "100% cotton shirts",
      "Pure cotton printed shirts",
      "Pure cotton Oxford shirts",
      "Pure cotton striped shirts",
      "Pure cotton check shirts",
      "Pure cotton textured shirts",
      "Pure cotton half sleeve shirts",
      "Pure cotton full sleeve shirts",
      "Pure cotton Cuban collar shirts"
    ],
    "100% cotton": [
      "100% cotton shirts",
      "100% cotton printed shirts",
      "100% cotton Oxford shirts",
      "100% cotton striped shirts",
      "100% cotton check shirts",
      "100% cotton textured shirts",
      "100% cotton half sleeve shirts",
      "100% cotton full sleeve shirts",
      "100% cotton regular fit shirts",
      "100% cotton Cuban collar shirts"
    ],
    "premium cotton": [
      "Premium cotton shirts",
      "100% premium cotton shirts",
      "Premium cotton printed shirts",
      "Premium cotton Oxford shirts",
      "Premium cotton striped shirts",
      "Premium cotton check shirts",
      "Premium cotton textured shirts",
      "Premium cotton half sleeve shirts",
      "Premium cotton full sleeve shirts",
      "Premium cotton Cuban collar shirts"
    ],
    "giza cotton": [
      "Giza cotton shirts",
      "Premium Giza cotton shirts",
      "Giza cotton printed shirts",
      "Giza cotton Cuban collar shirts",
      "Giza cotton half sleeve shirts",
      "Giza cotton regular fit shirts",
      "Giza cotton twill shirts",
      "Giza cotton abstract shirts",
      "Giza cotton olive shirts",
      "Giza cotton casual shirts"
    ],
    "linen": [
      "Linen shirts",
      "Pure linen shirts",
      "Linen cotton shirts",
      "Linen blend shirts",
      "Linen printed shirts",
      "Linen striped shirts",
      "Linen solid shirts",
      "Linen half sleeve shirts",
      "Linen full sleeve shirts",
      "Linen Mandarin collar shirts"
    ],
    "pure linen": [
      "Pure linen shirts",
      "100% pure linen shirts",
      "Pure linen full sleeve shirts",
      "Pure linen solid shirts",
      "Pure linen printed shirts",
      "Pure linen Mandarin collar shirts",
      "Pure linen popover shirts",
      "Pure linen Italian shirts",
      "Pure linen European shirts",
      "Pure linen regular fit shirts"
    ],
    "italian linen": [
      "Italian linen shirts",
      "Pure Italian linen shirts",
      "Italian linen cotton shirts",
      "Italian linen blend shirts",
      "Italian linen striped shirts",
      "Italian linen solid shirts",
      "Italian linen printed shirts",
      "Italian linen full sleeve shirts",
      "Italian linen half sleeve shirts",
      "Italian linen regular fit shirts"
    ],
    "european linen": [
      "European linen shirts",
      "Pure European linen shirts",
      "European linen cotton shirts",
      "European linen blend shirts",
      "European linen striped shirts",
      "European linen solid shirts",
      "European linen printed shirts",
      "European linen full sleeve shirts",
      "European linen Mandarin collar shirts",
      "European linen popover shirts"
    ],
    "satin": [
      "Satin shirts",
      "Cotton satin shirts",
      "Satin solid shirts",
      "Satin printed shirts",
      "Satin stretch shirts",
      "Satin full sleeve shirts",
      "Satin regular fit shirts",
      "Satin plain shirts",
      "Satin party shirts",
      "Satin luxe shirts"
    ],
    "lyocell": [
      "Lyocell shirts",
      "Lyocell linen shirts",
      "Lyocell blend shirts",
      "Lyocell viscose shirts",
      "Lyocell full sleeve shirts",
      "Lyocell solid shirts",
      "Lyocell printed shirts",
      "Lyocell crinkled shirts",
      "Lyocell textured shirts",
      "Lyocell regular fit shirts"
    ],
    "tencel": [
      "TENCEL shirts",
      "TENCEL fabric shirts",
      "TENCEL printed shirts",
      "TENCEL print shirts",
      "TENCEL Cuban collar shirts",
      "TENCEL half sleeve shirts",
      "TENCEL regular fit shirts",
      "TENCEL plain weave shirts",
      "TENCEL peach shirts",
      "TENCEL casual shirts"
    ],
    "viscose": [
      "Viscose shirts",
      "Viscose blend shirts",
      "Viscose nylon shirts",
      "Viscose linen shirts",
      "Viscose crinkled shirts",
      "Viscose printed shirts",
      "Viscose solid shirts",
      "Viscose half sleeve shirts",
      "Viscose full sleeve shirts",
      "Viscose regular fit shirts"
    ],
    "knit": [
      "Knit shirts",
      "Cotton knit shirts",
      "Knit striped shirts",
      "Knit solid shirts",
      "Slim fit knit shirts",
      "Knit full sleeve shirts",
      "Knit half sleeve shirts",
      "Cotton blend knit shirts",
      "Polyester knit shirts",
      "Knit regular fit shirts"
    ],
    "cotton knit": [
      "Cotton knit shirts",
      "Cotton blend knit shirts",
      "Cotton polyester knit shirts",
      "Cotton knit striped shirts",
      "Cotton knit solid shirts",
      "Cotton knit slim fit shirts",
      "Cotton knit full sleeve shirts",
      "Cotton knit half sleeve shirts",
      "Cotton knit regular fit shirts",
      "Cotton knit stretch shirts"
    ],
    "oxford": [
      "Oxford shirts",
      "Cotton Oxford shirts",
      "Oxford striped shirts",
      "Oxford check shirts",
      "Oxford solid shirts",
      "Oxford full sleeve shirts",
      "Oxford half sleeve shirts",
      "Oxford button-down shirts",
      "Oxford regular fit shirts",
      "Oxford cotton shirts"
    ],

    // ── BLEND & COMPOSITION SEARCHES ──────────────────────────────────
    "cotton blend": [
      "Cotton blend shirts",
      "Cotton polyester shirts",
      "Cotton blend knit shirts",
      "Cotton blend satin shirts",
      "Cotton blend printed shirts",
      "Cotton blend striped shirts",
      "Cotton blend solid shirts",
      "Cotton blend stretch shirts",
      "Cotton blend full sleeve shirts",
      "Cotton blend regular fit shirts"
    ],
    "linen blend": [
      "Linen blend shirts",
      "Linen cotton shirts",
      "Cotton linen shirts",
      "Linen viscose shirts",
      "Linen blend printed shirts",
      "Linen blend striped shirts",
      "Linen blend solid shirts",
      "Linen blend full sleeve shirts",
      "Linen blend half sleeve shirts",
      "Linen blend regular fit shirts"
    ],
    "cotton linen": [
      "Cotton linen shirts",
      "Linen cotton shirts",
      "Cotton linen printed shirts",
      "Cotton linen striped shirts",
      "Cotton linen solid shirts",
      "Cotton linen full sleeve shirts",
      "Cotton linen half sleeve shirts",
      "Cotton linen regular fit shirts",
      "Cotton linen Cuban collar shirts",
      "Cotton linen Mandarin collar shirts"
    ],
    "linen cotton": [
      "Linen cotton shirts",
      "Cotton linen shirts",
      "Linen cotton printed shirts",
      "Linen cotton striped shirts",
      "Linen cotton solid shirts",
      "Linen cotton full sleeve shirts",
      "Linen cotton half sleeve shirts",
      "Linen cotton regular fit shirts",
      "Linen cotton Cuban collar shirts",
      "Linen cotton Mandarin collar shirts"
    ],
    "cotton satin": [
      "Cotton satin shirts",
      "Satin cotton shirts",
      "Cotton satin solid shirts",
      "Cotton satin printed shirts",
      "Cotton satin stretch shirts",
      "Cotton satin full sleeve shirts",
      "Cotton satin regular fit shirts",
      "Cotton satin plain shirts",
      "Cotton satin party shirts",
      "Cotton satin luxe shirts"
    ],
    "cotton modal": [
      "Cotton modal shirts",
      "Cotton modal printed shirts",
      "Cotton modal print shirts",
      "Cotton modal abstract shirts",
      "Cotton modal metallic shirts",
      "Cotton modal full sleeve shirts",
      "Cotton modal regular fit shirts",
      "Cotton modal satin shirts",
      "Cotton modal solid shirts",
      "Cotton modal casual shirts"
    ],
    "cotton polyester": [
      "Cotton polyester shirts",
      "Cotton polyester knit shirts",
      "Cotton polyester blend shirts",
      "Cotton polyester striped shirts",
      "Cotton polyester solid shirts",
      "Cotton polyester slim fit shirts",
      "Cotton polyester full sleeve shirts",
      "Cotton polyester half sleeve shirts",
      "Cotton polyester stretch shirts",
      "Cotton polyester regular fit shirts"
    ],
    "polyester blend": [
      "Polyester blend shirts",
      "Cotton polyester shirts",
      "Polyester blend knit shirts",
      "Polyester blend striped shirts",
      "Polyester blend solid shirts",
      "Polyester blend slim fit shirts",
      "Polyester blend full sleeve shirts",
      "Polyester blend half sleeve shirts",
      "Polyester blend stretch shirts",
      "Polyester blend regular fit shirts"
    ],
    "cotton elastane": [
      "Cotton elastane shirts",
      "Cotton elastane stretch shirts",
      "Cotton elastane satin shirts",
      "Cotton elastane solid shirts",
      "Cotton elastane full sleeve shirts",
      "Cotton elastane regular fit shirts",
      "Cotton elastane party shirts",
      "Cotton elastane luxe shirts",
      "Cotton elastane plain shirts",
      "Cotton elastane formal shirts"
    ],
    "cotton lycra": [
      "Cotton Lycra shirts",
      "Cotton Lycra knit shirts",
      "Cotton Lycra stretch shirts",
      "Cotton Lycra blend shirts",
      "Cotton Lycra striped shirts",
      "Cotton Lycra solid shirts",
      "Cotton Lycra slim fit shirts",
      "Cotton Lycra full sleeve shirts",
      "Cotton Lycra half sleeve shirts",
      "Cotton Lycra regular fit shirts"
    ],
    "cotton stretch": [
      "Cotton stretch shirts",
      "Cotton stretch satin shirts",
      "Cotton stretch knit shirts",
      "Cotton stretch solid shirts",
      "Cotton stretch printed shirts",
      "Cotton stretch striped shirts",
      "Cotton stretch slim fit shirts",
      "Cotton stretch full sleeve shirts",
      "Cotton stretch half sleeve shirts",
      "Cotton stretch regular fit shirts"
    ],
    "viscose nylon": [
      "Viscose nylon shirts",
      "Viscose nylon blend shirts",
      "Viscose nylon crinkled shirts",
      "Viscose nylon printed shirts",
      "Viscose nylon solid shirts",
      "Viscose nylon textured shirts",
      "Viscose nylon half sleeve shirts",
      "Viscose nylon regular fit shirts",
      "Viscose nylon casual shirts",
      "Viscose nylon fabric shirts"
    ],
    "viscose linen": [
      "Viscose linen shirts",
      "Linen viscose shirts",
      "Viscose linen blend shirts",
      "Viscose linen twill shirts",
      "Viscose linen solid shirts",
      "Viscose linen textured shirts",
      "Viscose linen full sleeve shirts",
      "Viscose linen regular fit shirts",
      "Viscose linen casual shirts",
      "Viscose linen fabric shirts"
    ],
    "lyocell linen": [
      "Lyocell linen shirts",
      "Linen lyocell shirts",
      "Lyocell linen blend shirts",
      "Lyocell linen solid shirts",
      "Lyocell linen crinkled shirts",
      "Lyocell linen textured shirts",
      "Lyocell linen full sleeve shirts",
      "Lyocell linen regular fit shirts",
      "Lyocell linen viscose shirts",
      "Lyocell linen fabric shirts"
    ],
    "lyocell linen viscose": [
      "Lyocell linen viscose shirts",
      "Lyocell linen viscose blend shirts",
      "Lyocell linen viscose shirts",
      "Lyocell linen viscose solid shirts",
      "Lyocell linen viscose crinkled shirts",
      "Lyocell linen viscose textured shirts",
      "Lyocell linen viscose full sleeve shirts",
      "Lyocell linen viscose regular fit shirts",
      "Lyocell linen viscose casual shirts",
      "Lyocell linen viscose fabric shirts"
    ],
    "linen blend shirt": [
      "Linen blend shirts",
      "Linen cotton shirts",
      "Cotton linen shirts",
      "Linen blend printed shirts",
      "Linen blend striped shirts",
      "Linen blend solid shirts",
      "Linen blend full sleeve shirts",
      "Linen blend half sleeve shirts",
      "Linen blend regular fit shirts",
      "Linen blend Cuban collar shirts"
    ],
    "cotton blend shirt": [
      "Cotton blend shirts",
      "Cotton polyester shirts",
      "Cotton linen shirts",
      "Cotton blend knit shirts",
      "Cotton blend satin shirts",
      "Cotton blend printed shirts",
      "Cotton blend striped shirts",
      "Cotton blend solid shirts",
      "Cotton blend full sleeve shirts",
      "Cotton blend regular fit shirts"
    ],

    // ── WEAVE & FABRIC-FINISH SEARCHES ────────────────────────────────
    "plain weave": [
      "Plain weave shirts",
      "Plain weave linen shirts",
      "Plain weave cotton shirts",
      "Plain weave solid shirts",
      "Plain weave printed shirts",
      "Plain weave striped shirts",
      "Plain weave full sleeve shirts",
      "Plain weave half sleeve shirts",
      "Plain weave regular fit shirts",
      "Plain weave Cuban collar shirts"
    ],
    "oxford fabric": [
      "Oxford fabric shirts",
      "Oxford shirts",
      "Cotton Oxford shirts",
      "Oxford striped shirts",
      "Oxford check shirts",
      "Oxford solid shirts",
      "Oxford full sleeve shirts",
      "Oxford half sleeve shirts",
      "Oxford button-down shirts",
      "Oxford regular fit shirts"
    ],
    "oxford weave": [
      "Oxford weave shirts",
      "Oxford shirts",
      "Oxford cotton shirts",
      "Oxford striped shirts",
      "Oxford check shirts",
      "Oxford solid shirts",
      "Oxford full sleeve shirts",
      "Oxford half sleeve shirts",
      "Oxford button-down shirts",
      "Oxford regular fit shirts"
    ],
    "satin weave": [
      "Satin weave shirts",
      "Satin shirts",
      "Cotton satin shirts",
      "Satin solid shirts",
      "Satin printed shirts",
      "Satin stretch shirts",
      "Satin full sleeve shirts",
      "Satin regular fit shirts",
      "Satin luxe shirts",
      "Satin party shirts"
    ],
    "twill": [
      "Twill shirts",
      "Cotton twill shirts",
      "Twill check shirts",
      "Twill striped shirts",
      "Twill printed shirts",
      "Twill textured shirts",
      "Twill solid shirts",
      "Twill Cuban collar shirts",
      "Twill full sleeve shirts",
      "Twill half sleeve shirts",
      "Twill regular fit shirts"
    ],
    "textured weave": [
      "Textured weave shirts",
      "Textured shirts",
      "Textured cotton shirts",
      "Textured printed shirts",
      "Textured solid shirts",
      "Textured Cuban collar shirts",
      "Textured half sleeve shirts",
      "Textured knit shirts",
      "Textured regular fit shirts",
      "Textured casual shirts"
    ],
    "slub": [
      "Slub shirts",
      "Cotton slub shirts",
      "Dobby slub shirts",
      "Slub printed shirts",
      "Slub textured shirts",
      "Slub solid shirts",
      "Slub half sleeve shirts",
      "Slub full sleeve shirts",
      "Slub regular fit shirts",
      "Slub Cuban collar shirts"
    ],
    "dobby": [
      "Dobby shirts",
      "Cotton dobby shirts",
      "Dobby slub shirts",
      "Dobby printed shirts",
      "Dobby textured shirts",
      "Dobby solid shirts",
      "Dobby half sleeve shirts",
      "Dobby full sleeve shirts",
      "Dobby regular fit shirts",
      "Dobby Cuban collar shirts"
    ],
    "dobby slub": [
      "Dobby slub shirts",
      "Cotton dobby slub shirts",
      "Dobby slub printed shirts",
      "Dobby slub textured shirts",
      "Dobby slub solid shirts",
      "Dobby slub half sleeve shirts",
      "Dobby slub full sleeve shirts",
      "Dobby slub regular fit shirts",
      "Dobby slub Cuban collar shirts",
      "Dobby slub cotton shirts"
    ],
    "crinkle": [
      "Crinkle shirts",
      "Crinkled shirts",
      "Viscose crinkle shirts",
      "Crinkle printed shirts",
      "Crinkle solid shirts",
      "Crinkle textured shirts",
      "Crinkle half sleeve shirts",
      "Crinkle regular fit shirts",
      "Crinkle fabric shirts",
      "Crinkle casual shirts"
    ],
    "crinkled": [
      "Crinkled shirts",
      "Crinkle shirts",
      "Viscose crinkled shirts",
      "Crinkled printed shirts",
      "Crinkled solid shirts",
      "Crinkled textured shirts",
      "Crinkled half sleeve shirts",
      "Crinkled regular fit shirts",
      "Crinkled blend shirts",
      "Crinkled fabric shirts"
    ],
    "crinkled fabric": [
      "Crinkled fabric shirts",
      "Crinkle shirts",
      "Viscose crinkled shirts",
      "Crinkled printed shirts",
      "Crinkled solid shirts",
      "Crinkled textured shirts",
      "Crinkled half sleeve shirts",
      "Crinkled regular fit shirts",
      "Crinkled blend shirts",
      "Crinkled casual shirts"
    ],
    "micro-crinkled": [
      "Micro-crinkled shirts",
      "Micro-crinkle shirts",
      "Viscose micro-crinkled shirts",
      "Micro-crinkled printed shirts",
      "Micro-crinkled solid shirts",
      "Micro-crinkled textured shirts",
      "Micro-crinkled half sleeve shirts",
      "Micro-crinkled regular fit shirts",
      "Micro-crinkled blend shirts",
      "Micro-crinkled fabric shirts"
    ],
    "micro crinkled": [
      "Micro-crinkled shirts",
      "Micro-crinkle shirts",
      "Viscose micro-crinkled shirts",
      "Micro-crinkled printed shirts",
      "Micro-crinkled solid shirts",
      "Micro-crinkled textured shirts",
      "Micro-crinkled half sleeve shirts",
      "Micro-crinkled regular fit shirts",
      "Micro-crinkled blend shirts",
      "Micro-crinkled fabric shirts"
    ],
    "seersucker": [
      "Seersucker shirts",
      "Cotton seersucker shirts",
      "Seersucker striped shirts",
      "Seersucker textured shirts",
      "Seersucker puckered shirts",
      "Seersucker cotton shirts",
      "Seersucker short sleeve shirts",
      "Seersucker half sleeve shirts",
      "Seersucker regular fit shirts",
      "Seersucker casual shirts"
    ],
    "seersucker puckered texture": [
      "Seersucker shirts",
      "Cotton seersucker shirts",
      "Seersucker striped shirts",
      "Seersucker textured shirts",
      "Seersucker puckered shirts",
      "Seersucker cotton shirts",
      "Seersucker short sleeve shirts",
      "Seersucker half sleeve shirts",
      "Seersucker regular fit shirts",
      "Seersucker casual shirts"
    ],
    "linen texture": [
      "Linen texture shirts",
      "Linen shirts",
      "Linen cotton shirts",
      "Pure linen shirts",
      "Linen blend shirts",
      "Linen printed shirts",
      "Linen striped shirts",
      "Linen solid shirts",
      "Linen full sleeve shirts",
      "Linen half sleeve shirts"
    ],
    "natural/raw linen texture": [
      "Natural linen texture shirts",
      "Raw linen shirts",
      "Pure linen shirts",
      "Italian linen shirts",
      "European linen shirts",
      "Linen cotton shirts",
      "Linen blend shirts",
      "Linen solid shirts",
      "Linen full sleeve shirts",
      "Linen regular fit shirts"
    ],
    "natural linen texture": [
      "Natural linen texture shirts",
      "Raw linen shirts",
      "Pure linen shirts",
      "Italian linen shirts",
      "European linen shirts",
      "Linen cotton shirts",
      "Linen blend shirts",
      "Linen solid shirts",
      "Linen full sleeve shirts",
      "Linen regular fit shirts"
    ],
    "raw linen": [
      "Natural linen texture shirts",
      "Raw linen shirts",
      "Pure linen shirts",
      "Italian linen shirts",
      "European linen shirts",
      "Linen cotton shirts",
      "Linen blend shirts",
      "Linen solid shirts",
      "Linen full sleeve shirts",
      "Linen regular fit shirts"
    ],
    "uneven texture": [
      "Uneven texture shirts",
      "Cotton uneven texture shirts",
      "Uneven texture printed shirts",
      "Uneven texture cotton shirts",
      "Uneven texture slub shirts",
      "Uneven texture abstract shirts",
      "Uneven texture textured shirts",
      "Uneven texture half sleeve shirts",
      "Uneven texture regular fit shirts",
      "Uneven texture Cuban collar shirts"
    ],
    "micro-texture": [
      "Micro-texture shirts",
      "Cotton micro-texture shirts",
      "Micro-texture printed shirts",
      "Micro-texture textured shirts",
      "Micro-texture solid shirts",
      "Micro-texture cotton shirts",
      "Micro-texture half sleeve shirts",
      "Micro-texture full sleeve shirts",
      "Micro-texture regular fit shirts",
      "Micro-texture casual shirts"
    ],
    "micro texture": [
      "Micro-texture shirts",
      "Cotton micro-texture shirts",
      "Micro-texture printed shirts",
      "Micro-texture textured shirts",
      "Micro-texture solid shirts",
      "Micro-texture cotton shirts",
      "Micro-texture half sleeve shirts",
      "Micro-texture full sleeve shirts",
      "Micro-texture regular fit shirts",
      "Micro-texture casual shirts"
    ],
    "textured fabric": [
      "Textured fabric shirts",
      "Textured cotton shirts",
      "Textured printed shirts",
      "Textured solid shirts",
      "Textured Cuban collar shirts",
      "Textured half sleeve shirts",
      "Textured full sleeve shirts",
      "Textured regular fit shirts",
      "Textured knit shirts",
      "Textured casual shirts"
    ],
    "knit fabric": [
      "Knit fabric shirts",
      "Knit shirts",
      "Cotton knit shirts",
      "Knit striped shirts",
      "Knit solid shirts",
      "Knit slim fit shirts",
      "Knit full sleeve shirts",
      "Knit half sleeve shirts",
      "Cotton blend knit shirts",
      "Polyester knit shirts"
    ],
    "stretch fabric": [
      "Stretch fabric shirts",
      "Cotton stretch shirts",
      "Cotton elastane shirts",
      "Cotton Lycra shirts",
      "Satin stretch shirts",
      "Stretch knit shirts",
      "Stretch solid shirts",
      "Stretch printed shirts",
      "Stretch full sleeve shirts",
      "Stretch regular fit shirts"
    ],
    "smooth satin surface": [
      "Smooth satin shirts",
      "Smooth satin surface shirts",
      "Satin shirts",
      "Cotton satin shirts",
      "Satin solid shirts",
      "Satin printed shirts",
      "Satin stretch shirts",
      "Satin full sleeve shirts",
      "Satin regular fit shirts",
      "Satin luxe shirts"
    ],
    "smooth satin": [
      "Smooth satin shirts",
      "Smooth satin surface shirts",
      "Satin shirts",
      "Cotton satin shirts",
      "Satin solid shirts",
      "Satin printed shirts",
      "Satin stretch shirts",
      "Satin full sleeve shirts",
      "Satin regular fit shirts",
      "Satin luxe shirts"
    ],
    "soft-wash fabric": [
      "Soft-wash fabric shirts",
      "Soft-wash shirts",
      "Soft-wash cotton shirts",
      "Soft-wash Oxford shirts",
      "Soft-wash striped shirts",
      "Soft-wash check shirts",
      "Soft-wash solid shirts",
      "Soft-wash full sleeve shirts",
      "Soft-wash half sleeve shirts",
      "Soft-wash regular fit shirts"
    ],
    "soft-washed finish": [
      "Soft-washed shirts",
      "Soft-washed cotton shirts",
      "Soft-washed Oxford shirts",
      "Soft-washed striped shirts",
      "Soft-washed check shirts",
      "Soft-washed solid shirts",
      "Soft-washed full sleeve shirts",
      "Soft-washed half sleeve shirts",
      "Soft-washed regular fit shirts",
      "Soft-washed casual shirts"
    ],
    "soft washed finish": [
      "Soft-washed shirts",
      "Soft-washed cotton shirts",
      "Soft-washed Oxford shirts",
      "Soft-washed striped shirts",
      "Soft-washed check shirts",
      "Soft-washed solid shirts",
      "Soft-washed full sleeve shirts",
      "Soft-washed half sleeve shirts",
      "Soft-washed regular fit shirts",
      "Soft-washed casual shirts"
    ],
    "soft-washed": [
      "Soft-washed shirts",
      "Soft-washed cotton shirts",
      "Soft-washed Oxford shirts",
      "Soft-washed striped shirts",
      "Soft-washed check shirts",
      "Soft-washed solid shirts",
      "Soft-washed full sleeve shirts",
      "Soft-washed half sleeve shirts",
      "Soft-washed regular fit shirts",
      "Soft-washed casual shirts"
    ],
    "soft washed": [
      "Soft-washed shirts",
      "Soft-washed cotton shirts",
      "Soft-washed Oxford shirts",
      "Soft-washed striped shirts",
      "Soft-washed check shirts",
      "Soft-washed solid shirts",
      "Soft-washed full sleeve shirts",
      "Soft-washed half sleeve shirts",
      "Soft-washed regular fit shirts",
      "Soft-washed casual shirts"
    ],
    "porous knit texture": [
      "Porous knit shirts",
      "Knit shirts",
      "Cotton knit shirts",
      "Cotton polyester knit shirts",
      "Slim fit knit shirts",
      "Striped knit shirts",
      "Solid knit shirts",
      "Full sleeve knit shirts",
      "Half sleeve knit shirts",
      "Stretch knit shirts"
    ],
    "porous knit": [
      "Porous knit shirts",
      "Knit shirts",
      "Cotton knit shirts",
      "Cotton polyester knit shirts",
      "Slim fit knit shirts",
      "Striped knit shirts",
      "Solid knit shirts",
      "Full sleeve knit shirts",
      "Half sleeve knit shirts",
      "Stretch knit shirts"
    ],
    "matte texture": [
      "Matte texture shirts",
      "Matte finish shirts",
      "Cotton matte shirts",
      "Matte solid shirts",
      "Matte printed shirts",
      "Matte striped shirts",
      "Matte linen shirts",
      "Matte full sleeve shirts",
      "Matte regular fit shirts",
      "Matte casual shirts"
    ],
    "matte finish": [
      "Matte texture shirts",
      "Matte finish shirts",
      "Cotton matte shirts",
      "Matte solid shirts",
      "Matte printed shirts",
      "Matte striped shirts",
      "Matte linen shirts",
      "Matte full sleeve shirts",
      "Matte regular fit shirts",
      "Matte casual shirts"
    ],
    "subtle sheen or lustrous finish": [
      "Subtle sheen shirts",
      "Lustrous finish shirts",
      "Satin shirts",
      "Satin solid shirts",
      "Satin stretch shirts",
      "Cotton satin shirts",
      "Satin printed shirts",
      "Satin full sleeve shirts",
      "Satin regular fit shirts",
      "Satin luxe shirts"
    ],
    "subtle sheen": [
      "Subtle sheen shirts",
      "Lustrous finish shirts",
      "Satin shirts",
      "Satin solid shirts",
      "Satin stretch shirts",
      "Cotton satin shirts",
      "Satin printed shirts",
      "Satin full sleeve shirts",
      "Satin regular fit shirts",
      "Satin luxe shirts"
    ],
    "lustrous finish": [
      "Subtle sheen shirts",
      "Lustrous finish shirts",
      "Satin shirts",
      "Satin solid shirts",
      "Satin stretch shirts",
      "Cotton satin shirts",
      "Satin printed shirts",
      "Satin full sleeve shirts",
      "Satin regular fit shirts",
      "Satin luxe shirts"
    ],

    // ── PATTERNS & DESIGNS SEARCHES ───────────────────────────────────
    "solid": [
      "Solid shirts",
      "Cotton solid shirts",
      "Linen solid shirts",
      "Oxford solid shirts",
      "Satin solid shirts",
      "Knit solid shirts",
      "Solid full sleeve shirts",
      "Solid half sleeve shirts",
      "Solid regular fit shirts",
      "Solid stretch shirts"
    ],
    "striped": [
      "Striped shirts",
      "Cotton striped shirts",
      "Linen striped shirts",
      "Oxford striped shirts",
      "Knit striped shirts",
      "Vertical striped shirts",
      "Striped full sleeve shirts",
      "Striped half sleeve shirts",
      "Striped regular fit shirts",
      "Yarn-dyed striped shirts"
    ],
    "stripe": [
      "Striped shirts",
      "Cotton striped shirts",
      "Linen striped shirts",
      "Oxford striped shirts",
      "Knit striped shirts",
      "Vertical striped shirts",
      "Striped full sleeve shirts",
      "Striped half sleeve shirts",
      "Striped regular fit shirts",
      "Yarn-dyed striped shirts"
    ],
    "stripes": [
      "Striped shirts",
      "Cotton striped shirts",
      "Linen striped shirts",
      "Oxford striped shirts",
      "Knit striped shirts",
      "Vertical striped shirts",
      "Striped full sleeve shirts",
      "Striped half sleeve shirts",
      "Striped regular fit shirts",
      "Yarn-dyed striped shirts"
    ],
    "vertical stripe": [
      "Vertical stripe shirts",
      "Cotton vertical stripe shirts",
      "Linen vertical stripe shirts",
      "Seersucker stripe shirts",
      "Vertical stripe cotton shirts",
      "Vertical stripe linen shirts",
      "Vertical stripe full sleeve shirts",
      "Vertical stripe half sleeve shirts",
      "Vertical stripe regular fit shirts",
      "Vertical stripe casual shirts"
    ],
    "vertical stripes": [
      "Vertical stripe shirts",
      "Cotton vertical stripe shirts",
      "Linen vertical stripe shirts",
      "Seersucker stripe shirts",
      "Vertical stripe cotton shirts",
      "Vertical stripe linen shirts",
      "Vertical stripe full sleeve shirts",
      "Vertical stripe half sleeve shirts",
      "Vertical stripe regular fit shirts",
      "Vertical stripe casual shirts"
    ],
    "checked": [
      "Checked shirts",
      "Cotton checked shirts",
      "Oxford checked shirts",
      "Checked full sleeve shirts",
      "Checked half sleeve shirts",
      "Checked regular fit shirts",
      "Checked casual shirts",
      "Checked cotton shirts",
      "Checked twill shirts",
      "Yarn-dyed check shirts"
    ],
    "check": [
      "Checked shirts",
      "Cotton checked shirts",
      "Oxford checked shirts",
      "Checked full sleeve shirts",
      "Checked half sleeve shirts",
      "Checked regular fit shirts",
      "Checked casual shirts",
      "Checked cotton shirts",
      "Checked twill shirts",
      "Yarn-dyed check shirts"
    ],
    "checks": [
      "Checked shirts",
      "Cotton checked shirts",
      "Oxford checked shirts",
      "Checked full sleeve shirts",
      "Checked half sleeve shirts",
      "Checked regular fit shirts",
      "Checked casual shirts",
      "Checked cotton shirts",
      "Checked twill shirts",
      "Yarn-dyed check shirts"
    ],
    "checkered": [
      "Checkered shirts",
      "Cotton checkered shirts",
      "Oxford checkered shirts",
      "Checkered full sleeve shirts",
      "Checkered half sleeve shirts",
      "Checkered regular fit shirts",
      "Checkered cotton shirts",
      "Checkered twill shirts",
      "Checkered casual shirts",
      "Yarn-dyed check shirts"
    ],
    "grid": [
      "Grid shirts",
      "Cotton grid shirts",
      "Grid check shirts",
      "Grid printed shirts",
      "Grid textured shirts",
      "Grid twill shirts",
      "Grid full sleeve shirts",
      "Grid half sleeve shirts",
      "Grid regular fit shirts",
      "Grid casual shirts"
    ],
    "floral": [
      "Floral shirts",
      "Floral print shirts",
      "Cotton floral shirts",
      "Tropical floral shirts",
      "Floral Cuban collar shirts",
      "Floral half sleeve shirts",
      "Floral full sleeve shirts",
      "Floral regular fit shirts",
      "Floral linen shirts",
      "Floral casual shirts"
    ],
    "botanical": [
      "Botanical shirts",
      "Botanical print shirts",
      "Cotton botanical shirts",
      "Botanical leaf shirts",
      "Botanical foliage shirts",
      "Botanical half sleeve shirts",
      "Botanical full sleeve shirts",
      "Botanical regular fit shirts",
      "Botanical linen shirts",
      "Botanical casual shirts"
    ],
    "leaf": [
      "Leaf print shirts",
      "Leaf shirts",
      "Botanical leaf shirts",
      "Cotton leaf print shirts",
      "Navy leaf print shirts",
      "Leaf print half sleeve shirts",
      "Leaf print regular fit shirts",
      "Leaf print cotton shirts",
      "Leaf print casual shirts",
      "Leaf pattern shirts"
    ],
    "palm": [
      "Palm print shirts",
      "Palm shirts",
      "Crinkled palm print shirts",
      "Viscose palm print shirts",
      "Palm print half sleeve shirts",
      "Palm print regular fit shirts",
      "Palm print casual shirts",
      "Palm print fabric shirts",
      "Palm pattern shirts",
      "Printed palm shirts"
    ],
    "stormwater": [
      "Stormwater shirts",
      "Stormwater print shirts",
      "Crinkled stormwater shirts",
      "Viscose stormwater shirts",
      "Stormwater half sleeve shirts",
      "Stormwater regular fit shirts",
      "Stormwater printed shirts",
      "Stormwater casual shirts",
      "Stormwater fabric shirts",
      "Stormwater pattern shirts"
    ],
    "geometric": [
      "Geometric shirts",
      "Geometric print shirts",
      "Cotton geometric shirts",
      "Geometric ivory shirts",
      "Geometric olive shirts",
      "Geometric Cuban collar shirts",
      "Geometric half sleeve shirts",
      "Geometric regular fit shirts",
      "Geometric textured shirts",
      "Geometric casual shirts"
    ],
    "abstract": [
      "Abstract shirts",
      "Abstract print shirts",
      "Cotton abstract shirts",
      "Abstract blue shirts",
      "Abstract charcoal shirts",
      "Abstract Cuban collar shirts",
      "Abstract full sleeve shirts",
      "Abstract half sleeve shirts",
      "Abstract regular fit shirts",
      "Abstract casual shirts"
    ],
    "artistic": [
      "Artistic shirts",
      "Artistic print shirts",
      "Artistic abstract shirts",
      "Artistic maroon shirts",
      "Artistic charcoal shirts",
      "Artistic cotton shirts",
      "Artistic full sleeve shirts",
      "Artistic half sleeve shirts",
      "Artistic regular fit shirts",
      "Artistic casual shirts"
    ],
    "brush-stroke": [
      "Brush-stroke shirts",
      "Brush-stroke print shirts",
      "Cotton brush-stroke shirts",
      "Brush-stroke half sleeve shirts",
      "Brush-stroke regular fit shirts",
      "Brush-stroke cotton shirts",
      "Brush-stroke printed shirts",
      "Brush-stroke casual shirts",
      "Brush-stroke blue shirts",
      "Brush-stroke white shirts"
    ],
    "brush stroke": [
      "Brush-stroke shirts",
      "Brush-stroke print shirts",
      "Cotton brush-stroke shirts",
      "Brush-stroke half sleeve shirts",
      "Brush-stroke regular fit shirts",
      "Brush-stroke cotton shirts",
      "Brush-stroke printed shirts",
      "Brush-stroke casual shirts",
      "Brush-stroke blue shirts",
      "Brush-stroke white shirts"
    ],
    "wave": [
      "Wave shirts",
      "Wave print shirts",
      "Blue wave shirts",
      "Blue wave print shirts",
      "Cotton wave shirts",
      "Wave full sleeve shirts",
      "Wave printed shirts",
      "Wave regular fit shirts",
      "Wave casual shirts",
      "Wave pattern shirts"
    ],
    "marble-texture print": [
      "Marble-texture print shirts",
      "Marble print shirts",
      "Satin marble print shirts",
      "Cotton marble print shirts",
      "Marble texture shirts",
      "Marble full sleeve shirts",
      "Marble printed shirts",
      "Marble regular fit shirts",
      "Marble satin shirts",
      "Marble casual shirts"
    ],
    "marble texture print": [
      "Marble-texture print shirts",
      "Marble print shirts",
      "Satin marble print shirts",
      "Cotton marble print shirts",
      "Marble texture shirts",
      "Marble full sleeve shirts",
      "Marble printed shirts",
      "Marble regular fit shirts",
      "Marble satin shirts",
      "Marble casual shirts"
    ],
    "marble print": [
      "Marble-texture print shirts",
      "Marble print shirts",
      "Satin marble print shirts",
      "Cotton marble print shirts",
      "Marble texture shirts",
      "Marble full sleeve shirts",
      "Marble printed shirts",
      "Marble regular fit shirts",
      "Marble satin shirts",
      "Marble casual shirts"
    ],
    "metallic print": [
      "Metallic print shirts",
      "Metallic blue shirts",
      "Abstract metallic shirts",
      "Blue metallic print shirts",
      "Cotton metallic shirts",
      "Satin metallic shirts",
      "Metallic full sleeve shirts",
      "Metallic printed shirts",
      "Metallic regular fit shirts",
      "Metallic party shirts"
    ],
    "tropical print": [
      "Tropical print shirts",
      "Tropical floral shirts",
      "Tropical cotton shirts",
      "Tropical Cuban collar shirts",
      "Tropical printed shirts",
      "Tropical half sleeve shirts",
      "Tropical full sleeve shirts",
      "Tropical regular fit shirts",
      "Tropical leaf shirts",
      "Tropical casual shirts"
    ],
    "tropical": [
      "Tropical print shirts",
      "Tropical floral shirts",
      "Tropical cotton shirts",
      "Tropical Cuban collar shirts",
      "Tropical printed shirts",
      "Tropical half sleeve shirts",
      "Tropical full sleeve shirts",
      "Tropical regular fit shirts",
      "Tropical leaf shirts",
      "Tropical casual shirts"
    ],
    "foliage print": [
      "Foliage print shirts",
      "Foliage shirts",
      "Botanical foliage shirts",
      "Cotton foliage shirts",
      "Foliage printed shirts",
      "Foliage half sleeve shirts",
      "Foliage full sleeve shirts",
      "Foliage regular fit shirts",
      "Foliage brown shirts",
      "Foliage casual shirts"
    ],
    "foliage": [
      "Foliage print shirts",
      "Foliage shirts",
      "Botanical foliage shirts",
      "Cotton foliage shirts",
      "Foliage printed shirts",
      "Foliage half sleeve shirts",
      "Foliage full sleeve shirts",
      "Foliage regular fit shirts",
      "Foliage brown shirts",
      "Foliage casual shirts"
    ],
    "bloom print": [
      "Bloom print shirts",
      "Bloom shirts",
      "Burgundy bloom shirts",
      "Floral bloom shirts",
      "Cotton bloom shirts",
      "Bloom printed shirts",
      "Bloom half sleeve shirts",
      "Bloom regular fit shirts",
      "Bloom casual shirts",
      "Bloom pattern shirts"
    ],
    "bloom": [
      "Bloom print shirts",
      "Bloom shirts",
      "Burgundy bloom shirts",
      "Floral bloom shirts",
      "Cotton bloom shirts",
      "Bloom printed shirts",
      "Bloom half sleeve shirts",
      "Bloom regular fit shirts",
      "Bloom casual shirts",
      "Bloom pattern shirts"
    ],
    "monochrome print": [
      "Monochrome print shirts",
      "Monochrome shirts",
      "Black and white print shirts",
      "Monochrome abstract shirts",
      "Monochrome cotton shirts",
      "Monochrome Cuban collar shirts",
      "Monochrome half sleeve shirts",
      "Monochrome regular fit shirts",
      "Monochrome casual shirts",
      "Monochrome pattern shirts"
    ],
    "monochrome": [
      "Monochrome print shirts",
      "Monochrome shirts",
      "Black and white print shirts",
      "Monochrome abstract shirts",
      "Monochrome cotton shirts",
      "Monochrome Cuban collar shirts",
      "Monochrome half sleeve shirts",
      "Monochrome regular fit shirts",
      "Monochrome casual shirts",
      "Monochrome pattern shirts"
    ],

    // ── FABRIC-LED PATTERNS ───────────────────────────────────────────
    "satin print": [
      "Satin print shirts",
      "Cotton satin print shirts",
      "Satin printed shirts",
      "Satin marble print shirts",
      "Satin abstract shirts",
      "Satin full sleeve shirts",
      "Satin regular fit shirts",
      "Satin stretch shirts",
      "Satin blue shirts",
      "Satin party shirts"
    ],
    "linen print": [
      "Linen print shirts",
      "Linen cotton print shirts",
      "Cotton linen print shirts",
      "Linen floral shirts",
      "Linen printed shirts",
      "Linen half sleeve shirts",
      "Linen full sleeve shirts",
      "Linen regular fit shirts",
      "Linen Cuban collar shirts",
      "Linen casual shirts"
    ],
    "crinkled print": [
      "Crinkled print shirts",
      "Crinkle print shirts",
      "Viscose crinkled shirts",
      "Crinkled palm print shirts",
      "Crinkled stormwater shirts",
      "Crinkled half sleeve shirts",
      "Crinkled regular fit shirts",
      "Crinkled printed shirts",
      "Crinkled blend shirts",
      "Crinkled casual shirts"
    ],
    "crinkle print": [
      "Crinkled print shirts",
      "Crinkle print shirts",
      "Viscose crinkled shirts",
      "Crinkled palm print shirts",
      "Crinkled stormwater shirts",
      "Crinkled half sleeve shirts",
      "Crinkled regular fit shirts",
      "Crinkled printed shirts",
      "Crinkled blend shirts",
      "Crinkled casual shirts"
    ],
    "textured print": [
      "Textured print shirts",
      "Textured cotton shirts",
      "Textured printed shirts",
      "Textured Cuban collar shirts",
      "Textured geometric shirts",
      "Textured abstract shirts",
      "Textured half sleeve shirts",
      "Textured full sleeve shirts",
      "Textured regular fit shirts",
      "Textured casual shirts"
    ],

    // ── KNIT, OXFORD & STRIPE PATTERNS ───────────────────────────────
    "knit stripe": [
      "Knit stripe shirts",
      "Knit striped shirts",
      "Cotton knit stripe shirts",
      "Slim fit knit stripe shirts",
      "Knit stripe full sleeve shirts",
      "Knit stripe solid shirts",
      "Blue knit stripe shirts",
      "Pink knit stripe shirts",
      "Knit stripe regular fit shirts",
      "Cotton blend knit stripe shirts"
    ],
    "knit striped": [
      "Knit stripe shirts",
      "Knit striped shirts",
      "Cotton knit stripe shirts",
      "Slim fit knit stripe shirts",
      "Knit stripe full sleeve shirts",
      "Knit stripe solid shirts",
      "Blue knit stripe shirts",
      "Pink knit stripe shirts",
      "Knit stripe regular fit shirts",
      "Cotton blend knit stripe shirts"
    ],
    "oxford stripe": [
      "Oxford stripe shirts",
      "Oxford striped shirts",
      "Cotton Oxford stripe shirts",
      "Oxford blue stripe shirts",
      "Oxford grey stripe shirts",
      "Oxford beige stripe shirts",
      "Oxford navy stripe shirts",
      "Oxford stripe full sleeve shirts",
      "Oxford stripe regular fit shirts",
      "Oxford cotton striped shirts"
    ],
    "oxford striped": [
      "Oxford stripe shirts",
      "Oxford striped shirts",
      "Cotton Oxford stripe shirts",
      "Oxford blue stripe shirts",
      "Oxford grey stripe shirts",
      "Oxford beige stripe shirts",
      "Oxford navy stripe shirts",
      "Oxford stripe full sleeve shirts",
      "Oxford stripe regular fit shirts",
      "Oxford cotton striped shirts"
    ],
    "oxford check": [
      "Oxford check shirts",
      "Oxford checked shirts",
      "Cotton Oxford check shirts",
      "Blue Oxford check shirts",
      "Grey Oxford check shirts",
      "Oxford check full sleeve shirts",
      "Oxford check regular fit shirts",
      "Oxford check cotton shirts",
      "Oxford check casual shirts",
      "Oxford check fabric shirts"
    ],
    "oxford checked": [
      "Oxford check shirts",
      "Oxford checked shirts",
      "Cotton Oxford check shirts",
      "Blue Oxford check shirts",
      "Grey Oxford check shirts",
      "Oxford check full sleeve shirts",
      "Oxford check regular fit shirts",
      "Oxford check cotton shirts",
      "Oxford check casual shirts",
      "Oxford check fabric shirts"
    ],
    "seersucker stripe": [
      "Seersucker stripe shirts",
      "Seersucker striped shirts",
      "Cotton seersucker shirts",
      "Seersucker vertical stripe shirts",
      "Seersucker textured shirts",
      "Seersucker puckered shirts",
      "Seersucker short sleeve shirts",
      "Seersucker half sleeve shirts",
      "Seersucker regular fit shirts",
      "Seersucker cotton shirts"
    ],
    "seersucker striped": [
      "Seersucker stripe shirts",
      "Seersucker striped shirts",
      "Cotton seersucker shirts",
      "Seersucker vertical stripe shirts",
      "Seersucker textured shirts",
      "Seersucker puckered shirts",
      "Seersucker short sleeve shirts",
      "Seersucker half sleeve shirts",
      "Seersucker regular fit shirts",
      "Seersucker cotton shirts"
    ],
    "yarn-dyed stripe": [
      "Yarn-dyed stripe shirts",
      "Yarn-dyed striped shirts",
      "Cotton yarn-dyed shirts",
      "Oxford yarn-dyed shirts",
      "Linen yarn-dyed shirts",
      "Yarn-dyed full sleeve shirts",
      "Yarn-dyed half sleeve shirts",
      "Yarn-dyed regular fit shirts",
      "Yarn-dyed cotton shirts",
      "Yarn-dyed casual shirts"
    ],
    "yarn dyed stripe": [
      "Yarn-dyed stripe shirts",
      "Yarn-dyed striped shirts",
      "Cotton yarn-dyed shirts",
      "Oxford yarn-dyed shirts",
      "Linen yarn-dyed shirts",
      "Yarn-dyed full sleeve shirts",
      "Yarn-dyed half sleeve shirts",
      "Yarn-dyed regular fit shirts",
      "Yarn-dyed cotton shirts",
      "Yarn-dyed casual shirts"
    ],
    "yarn-dyed striped": [
      "Yarn-dyed stripe shirts",
      "Yarn-dyed striped shirts",
      "Cotton yarn-dyed shirts",
      "Oxford yarn-dyed shirts",
      "Linen yarn-dyed shirts",
      "Yarn-dyed full sleeve shirts",
      "Yarn-dyed half sleeve shirts",
      "Yarn-dyed regular fit shirts",
      "Yarn-dyed cotton shirts",
      "Yarn-dyed casual shirts"
    ],
    "yarn dyed striped": [
      "Yarn-dyed stripe shirts",
      "Yarn-dyed striped shirts",
      "Cotton yarn-dyed shirts",
      "Oxford yarn-dyed shirts",
      "Linen yarn-dyed shirts",
      "Yarn-dyed full sleeve shirts",
      "Yarn-dyed half sleeve shirts",
      "Yarn-dyed regular fit shirts",
      "Yarn-dyed cotton shirts",
      "Yarn-dyed casual shirts"
    ],
    "yarn-dyed check": [
      "Yarn-dyed check shirts",
      "Yarn-dyed checked shirts",
      "Cotton yarn-dyed check shirts",
      "Oxford yarn-dyed check shirts",
      "Twill yarn-dyed check shirts",
      "Yarn-dyed check full sleeve shirts",
      "Yarn-dyed check half sleeve shirts",
      "Yarn-dyed check regular fit shirts",
      "Yarn-dyed cotton shirts",
      "Yarn-dyed casual shirts"
    ],
    "yarn dyed check": [
      "Yarn-dyed check shirts",
      "Yarn-dyed checked shirts",
      "Cotton yarn-dyed check shirts",
      "Oxford yarn-dyed check shirts",
      "Twill yarn-dyed check shirts",
      "Yarn-dyed check full sleeve shirts",
      "Yarn-dyed check half sleeve shirts",
      "Yarn-dyed check regular fit shirts",
      "Yarn-dyed cotton shirts",
      "Yarn-dyed casual shirts"
    ],
    "yarn-dyed checked": [
      "Yarn-dyed check shirts",
      "Yarn-dyed checked shirts",
      "Cotton yarn-dyed check shirts",
      "Oxford yarn-dyed check shirts",
      "Twill yarn-dyed check shirts",
      "Yarn-dyed check full sleeve shirts",
      "Yarn-dyed check half sleeve shirts",
      "Yarn-dyed check regular fit shirts",
      "Yarn-dyed cotton shirts",
      "Yarn-dyed casual shirts"
    ],
    "yarn dyed checked": [
      "Yarn-dyed check shirts",
      "Yarn-dyed checked shirts",
      "Cotton yarn-dyed check shirts",
      "Oxford yarn-dyed check shirts",
      "Twill yarn-dyed check shirts",
      "Yarn-dyed check full sleeve shirts",
      "Yarn-dyed check half sleeve shirts",
      "Yarn-dyed check regular fit shirts",
      "Yarn-dyed cotton shirts",
      "Yarn-dyed casual shirts"
    ],

    // ── FIT SEARCHES ──────────────────────────────────────────────────
    "fit": [
      "Shirt fit",
      "Regular fit shirts",
      "Slim fit shirts",
      "Regular fit cotton shirts",
      "Regular fit linen shirts",
      "Regular fit Oxford shirts",
      "Regular fit printed shirts",
      "Regular fit satin shirts",
      "Slim fit knit shirts",
      "Slim fit striped shirts"
    ],
    "regular fit": [
      "Regular fit shirts",
      "Regular fit cotton shirts",
      "Regular fit linen shirts",
      "Regular fit printed shirts",
      "Regular fit Oxford shirts",
      "Regular fit satin shirts",
      "Regular fit textured shirts",
      "Regular fit Cuban collar shirts",
      "Regular fit full sleeve shirts",
      "Regular fit half sleeve shirts"
    ],
    "regular-fit": [
      "Regular fit shirts",
      "Regular fit cotton shirts",
      "Regular fit linen shirts",
      "Regular fit printed shirts",
      "Regular fit Oxford shirts",
      "Regular fit satin shirts",
      "Regular fit textured shirts",
      "Regular fit Cuban collar shirts",
      "Regular fit full sleeve shirts",
      "Regular fit half sleeve shirts"
    ],
    "regular fits": [
      "Regular fit shirts",
      "Regular fit cotton shirts",
      "Regular fit linen shirts",
      "Regular fit printed shirts",
      "Regular fit Oxford shirts",
      "Regular fit satin shirts",
      "Regular fit textured shirts",
      "Regular fit Cuban collar shirts",
      "Regular fit full sleeve shirts",
      "Regular fit half sleeve shirts"
    ],
    "slim fit": [
      "Slim fit shirts",
      "Slim fit knit shirts",
      "Slim fit satin shirts",
      "Slim fit striped shirts",
      "Slim fit cotton blend shirts",
      "Slim fit stretch shirts",
      "Slim fit solid shirts",
      "Slim fit full sleeve shirts",
      "Slim fit half sleeve shirts",
      "Slim fit regular shirts"
    ],
    "slim-fit": [
      "Slim fit shirts",
      "Slim fit knit shirts",
      "Slim fit satin shirts",
      "Slim fit striped shirts",
      "Slim fit cotton blend shirts",
      "Slim fit stretch shirts",
      "Slim fit solid shirts",
      "Slim fit full sleeve shirts",
      "Slim fit half sleeve shirts",
      "Slim fit regular shirts"
    ],
    "slim fits": [
      "Slim fit shirts",
      "Slim fit knit shirts",
      "Slim fit satin shirts",
      "Slim fit striped shirts",
      "Slim fit cotton blend shirts",
      "Slim fit stretch shirts",
      "Slim fit solid shirts",
      "Slim fit full sleeve shirts",
      "Slim fit half sleeve shirts",
      "Slim fit regular shirts"
    ],

    // ── SLEEVE SEARCHES & SYNONYM MAPPINGS ────────────────────────────
    "sleeves": [
      "Full sleeve shirts",
      "Half sleeve shirts",
      "Short sleeve shirts",
      "Long sleeve shirts",
      "Full sleeve cotton shirts",
      "Half sleeve cotton shirts",
      "Full sleeve linen shirts",
      "Half sleeve linen shirts",
      "Full sleeve printed shirts",
      "Half sleeve printed shirts"
    ],
    "sleeve": [
      "Full sleeve shirts",
      "Half sleeve shirts",
      "Short sleeve shirts",
      "Long sleeve shirts",
      "Full sleeve cotton shirts",
      "Half sleeve cotton shirts",
      "Full sleeve linen shirts",
      "Half sleeve linen shirts",
      "Full sleeve printed shirts",
      "Half sleeve printed shirts"
    ],
    "full sleeve": [
      "Full sleeve shirts",
      "Full sleeve cotton shirts",
      "Full sleeve linen shirts",
      "Full sleeve printed shirts",
      "Full sleeve Oxford shirts",
      "Full sleeve satin shirts",
      "Full sleeve knit shirts",
      "Full sleeve striped shirts",
      "Full sleeve regular fit shirts",
      "Full sleeve slim fit shirts"
    ],
    "full sleeves": [
      "Full sleeve shirts",
      "Full sleeve cotton shirts",
      "Full sleeve linen shirts",
      "Full sleeve printed shirts",
      "Full sleeve Oxford shirts",
      "Full sleeve satin shirts",
      "Full sleeve knit shirts",
      "Full sleeve striped shirts",
      "Full sleeve regular fit shirts",
      "Full sleeve slim fit shirts"
    ],
    "long sleeve": [
      "Long sleeve shirts",
      "Long sleeve cotton shirts",
      "Long sleeve linen shirts",
      "Long sleeve printed shirts",
      "Long sleeve Oxford shirts",
      "Long sleeve satin shirts",
      "Long sleeve knit shirts",
      "Long sleeve striped shirts",
      "Long sleeve regular fit shirts",
      "Long sleeve slim fit shirts"
    ],
    "long sleeves": [
      "Long sleeve shirts",
      "Long sleeve cotton shirts",
      "Long sleeve linen shirts",
      "Long sleeve printed shirts",
      "Long sleeve Oxford shirts",
      "Long sleeve satin shirts",
      "Long sleeve knit shirts",
      "Long sleeve striped shirts",
      "Long sleeve regular fit shirts",
      "Long sleeve slim fit shirts"
    ],
    "half sleeve": [
      "Half sleeve shirts",
      "Half sleeve cotton shirts",
      "Half sleeve linen shirts",
      "Half sleeve printed shirts",
      "Half sleeve Oxford shirts",
      "Half sleeve Cuban collar shirts",
      "Half sleeve textured shirts",
      "Half sleeve crinkled shirts",
      "Half sleeve regular fit shirts",
      "Half sleeve knit shirts"
    ],
    "half sleeves": [
      "Half sleeve shirts",
      "Half sleeve cotton shirts",
      "Half sleeve linen shirts",
      "Half sleeve printed shirts",
      "Half sleeve Oxford shirts",
      "Half sleeve Cuban collar shirts",
      "Half sleeve textured shirts",
      "Half sleeve crinkled shirts",
      "Half sleeve regular fit shirts",
      "Half sleeve knit shirts"
    ],
    "short sleeve": [
      "Short sleeve shirts",
      "Short sleeve cotton shirts",
      "Short sleeve seersucker shirts",
      "Short sleeve textured shirts",
      "Short sleeve striped shirts",
      "Short sleeve solid shirts",
      "Short sleeve printed shirts",
      "Short sleeve utility shirts",
      "Short sleeve regular fit shirts",
      "Short sleeve casual shirts"
    ],
    "short sleeves": [
      "Short sleeve shirts",
      "Short sleeve cotton shirts",
      "Short sleeve seersucker shirts",
      "Short sleeve textured shirts",
      "Short sleeve striped shirts",
      "Short sleeve solid shirts",
      "Short sleeve printed shirts",
      "Short sleeve utility shirts",
      "Short sleeve regular fit shirts",
      "Short sleeve casual shirts"
    ],

    // ── COLLAR SEARCHES ───────────────────────────────────────────────
    "collar": [
      "Collar shirts",
      "Cuban collar shirts",
      "Mandarin collar shirts",
      "Spread collar shirts",
      "Button-down collar shirts",
      "Classic collar shirts",
      "Structured collar shirts",
      "Interlined collar shirts",
      "Popover shirts",
      "Half-button shirts"
    ],
    "cuban collar": [
      "Cuban collar shirts",
      "Cuban collar printed shirts",
      "Cuban collar textured shirts",
      "Cuban collar cotton shirts",
      "Cuban collar linen shirts",
      "Cuban collar satin shirts",
      "Cuban collar half sleeve shirts",
      "Cuban collar regular fit shirts",
      "Cuban collar floral shirts",
      "Cuban collar geometric shirts"
    ],
    "mandarin collar": [
      "Mandarin collar shirts",
      "Mandarin collar linen shirts",
      "Mandarin collar pure linen shirts",
      "Mandarin collar cotton linen shirts",
      "Mandarin collar European linen shirts",
      "Mandarin collar white shirts",
      "Mandarin collar pink shirts",
      "Mandarin collar solid shirts",
      "Mandarin collar full sleeve shirts",
      "Mandarin collar regular fit shirts"
    ],
    "spread collar": [
      "Spread collar shirts",
      "Spread collar cotton shirts",
      "Spread collar linen shirts",
      "Spread collar linen cotton shirts",
      "Spread collar printed shirts",
      "Spread collar striped shirts",
      "Spread collar solid shirts",
      "Spread collar full sleeve shirts",
      "Spread collar half sleeve shirts",
      "Spread collar regular fit shirts"
    ],
    "button-down collar": [
      "Button-down collar shirts",
      "Button-down Oxford shirts",
      "Button-down cotton shirts",
      "Button-down solid shirts",
      "Button-down striped shirts",
      "Button-down check shirts",
      "Button-down white shirts",
      "Button-down full sleeve shirts",
      "Button-down half sleeve shirts",
      "Button-down regular fit shirts"
    ],
    "button down collar": [
      "Button-down collar shirts",
      "Button-down Oxford shirts",
      "Button-down cotton shirts",
      "Button-down solid shirts",
      "Button-down striped shirts",
      "Button-down check shirts",
      "Button-down white shirts",
      "Button-down full sleeve shirts",
      "Button-down half sleeve shirts",
      "Button-down regular fit shirts"
    ],
    "classic collar": [
      "Classic collar shirts",
      "Classic cotton shirts",
      "Classic Oxford shirts",
      "Classic striped shirts",
      "Classic check shirts",
      "Classic solid shirts",
      "Classic white shirts",
      "Classic full sleeve shirts",
      "Classic half sleeve shirts",
      "Classic regular fit shirts"
    ],
    "structured collar": [
      "Structured collar shirts",
      "Structured cotton shirts",
      "Structured Oxford shirts",
      "Structured spread collar shirts",
      "Structured button-down shirts",
      "Structured solid shirts",
      "Structured striped shirts",
      "Structured check shirts",
      "Structured full sleeve shirts",
      "Structured regular fit shirts"
    ],
    "interlined collar": [
      "Interlined collar shirts",
      "Interlined cotton shirts",
      "Interlined linen shirts",
      "Interlined printed shirts",
      "Interlined solid shirts",
      "Interlined spread collar shirts",
      "Interlined Cuban collar shirts",
      "Interlined full sleeve shirts",
      "Interlined half sleeve shirts",
      "Interlined regular fit shirts"
    ],

    // ── POPOVER & HALF-BUTTON SEARCHES ────────────────────────────────
    "popover": [
      "Popover shirts",
      "Half-button shirts",
      "Linen popover shirts",
      "Pure linen popover shirts",
      "European linen popover shirts",
      "White linen popover shirts",
      "Solid linen popover shirts",
      "Full sleeve popover shirts",
      "Regular fit popover shirts",
      "Half-button linen shirts"
    ],
    "half-button": [
      "Popover shirts",
      "Half-button shirts",
      "Linen popover shirts",
      "Pure linen popover shirts",
      "European linen popover shirts",
      "White linen popover shirts",
      "Solid linen popover shirts",
      "Full sleeve popover shirts",
      "Regular fit popover shirts",
      "Half-button linen shirts"
    ],
    "half button": [
      "Popover shirts",
      "Half-button shirts",
      "Linen popover shirts",
      "Pure linen popover shirts",
      "European linen popover shirts",
      "White linen popover shirts",
      "Solid linen popover shirts",
      "Full sleeve popover shirts",
      "Regular fit popover shirts",
      "Half-button linen shirts"
    ],
    "popover construction with a half-button placket": [
      "Popover shirts",
      "Half-button shirts",
      "Linen popover shirts",
      "Pure linen popover shirts",
      "European linen popover shirts",
      "White linen popover shirts",
      "Solid linen popover shirts",
      "Full sleeve popover shirts",
      "Regular fit popover shirts",
      "Half-button linen shirts"
    ],

    // ── NEUTRAL COLORS ────────────────────────────────────────────────
    "black": [
      "Black shirts",
      "Black printed shirts",
      "Black textured shirts",
      "Black satin shirts",
      "Black Cuban collar shirts",
      "Black knit shirts",
      "Black linen shirts",
      "Black check shirts",
      "Black full sleeve shirts",
      "Black half sleeve shirts"
    ],
    "midnight black": [
      "Midnight black shirts",
      "Midnight black satin shirts",
      "Midnight black solid shirts",
      "Midnight black stretch shirts",
      "Midnight black luxe shirts",
      "Midnight black full sleeve shirts",
      "Midnight black regular fit shirts",
      "Midnight black cotton shirts",
      "Midnight black party shirts",
      "Midnight black formal shirts"
    ],
    "white": [
      "White shirts",
      "White linen shirts",
      "White Oxford shirts",
      "White printed shirts",
      "White striped shirts",
      "White check shirts",
      "White solid shirts",
      "White Mandarin collar shirts",
      "White full sleeve shirts",
      "White popover shirts"
    ],
    "off white": [
      "Off white shirts",
      "Off white linen shirts",
      "Off white textured shirts",
      "Off white Cuban collar shirts",
      "Off white crinkled shirts",
      "Off white solid shirts",
      "Off white printed shirts",
      "Off white cotton shirts",
      "Off white full sleeve shirts",
      "Off white regular fit shirts"
    ],
    "off-white": [
      "Off white shirts",
      "Off white linen shirts",
      "Off white textured shirts",
      "Off white Cuban collar shirts",
      "Off white crinkled shirts",
      "Off white solid shirts",
      "Off white printed shirts",
      "Off white cotton shirts",
      "Off white full sleeve shirts",
      "Off white regular fit shirts"
    ],
    "ivory": [
      "Ivory shirts",
      "Ivory printed shirts",
      "Ivory linen shirts",
      "Ivory textured shirts",
      "Ivory geometric shirts",
      "Ivory cotton shirts",
      "Ivory solid shirts",
      "Ivory half sleeve shirts",
      "Ivory regular fit shirts",
      "Ivory cotton linen shirts"
    ],
    "ivory mist": [
      "Ivory mist shirts",
      "Ivory mist printed shirts",
      "Ivory mist cotton shirts",
      "Ivory mist textured shirts",
      "Ivory mist half sleeve shirts",
      "Ivory mist regular fit shirts",
      "Ivory mist casual shirts",
      "Ivory mist solid shirts",
      "Ivory mist abstract shirts",
      "Ivory mist fabric shirts"
    ],
    "cream": [
      "Cream shirts",
      "Cream linen shirts",
      "Cream cotton shirts",
      "Cream solid shirts",
      "Cream printed shirts",
      "Cream striped shirts",
      "Cream full sleeve shirts",
      "Cream half sleeve shirts",
      "Cream regular fit shirts",
      "Cream casual shirts"
    ],
    "dark cream": [
      "Dark cream shirts",
      "Dark cream linen shirts",
      "Dark cream cotton linen shirts",
      "Dark cream solid shirts",
      "Dark cream half sleeve shirts",
      "Dark cream regular fit shirts",
      "Dark cream full sleeve shirts",
      "Dark cream blend shirts",
      "Dark cream casual shirts",
      "Dark cream fabric shirts"
    ],
    "natural": [
      "Natural shirts",
      "Natural linen shirts",
      "Natural lyocell shirts",
      "Natural lyocell linen shirts",
      "Natural crinkled shirts",
      "Natural full sleeve shirts",
      "Natural blend shirts",
      "Natural solid shirts",
      "Natural regular fit shirts",
      "Natural fabric shirts"
    ],
    "beige": [
      "Beige shirts",
      "Beige satin shirts",
      "Beige striped shirts",
      "Beige Oxford shirts",
      "Beige solid shirts",
      "Beige stretch shirts",
      "Beige full sleeve shirts",
      "Beige regular fit shirts",
      "Beige cotton shirts",
      "Beige linen shirts"
    ],
    "sand beige": [
      "Sand beige shirts",
      "Sand beige knit shirts",
      "Sand beige cotton shirts",
      "Sand beige solid shirts",
      "Sand beige slim fit shirts",
      "Sand beige full sleeve shirts",
      "Sand beige stretch shirts",
      "Sand beige regular fit shirts",
      "Sand beige blend shirts",
      "Sand beige casual shirts"
    ],
    "brown": [
      "Brown shirts",
      "Brown printed shirts",
      "Brown satin shirts",
      "Brown linen shirts",
      "Brown textured shirts",
      "Brown Cuban collar shirts",
      "Brown solid shirts",
      "Brown full sleeve shirts",
      "Brown half sleeve shirts",
      "Brown regular fit shirts"
    ],
    "mocha brown": [
      "Mocha brown shirts",
      "Mocha brown knit shirts",
      "Mocha brown satin shirts",
      "Mocha brown solid shirts",
      "Mocha brown slim fit shirts",
      "Mocha brown stretch shirts",
      "Mocha brown full sleeve shirts",
      "Mocha brown cotton shirts",
      "Mocha brown regular fit shirts",
      "Mocha brown casual shirts"
    ],
    "coffee": [
      "Coffee shirts",
      "Coffee solid shirts",
      "Coffee printed shirts",
      "Coffee cotton shirts",
      "Coffee linen shirts",
      "Coffee satin shirts",
      "Coffee full sleeve shirts",
      "Coffee half sleeve shirts",
      "Coffee regular fit shirts",
      "Coffee casual shirts"
    ],
    "dark espresso": [
      "Dark espresso shirts",
      "Dark espresso striped shirts",
      "Dark espresso vertical stripe shirts",
      "Dark espresso cotton shirts",
      "Dark espresso viscose shirts",
      "Dark espresso textured shirts",
      "Dark espresso solid shirts",
      "Dark espresso full sleeve shirts",
      "Dark espresso regular fit shirts",
      "Dark espresso casual shirts"
    ],

    // ── BLUE COLORS ───────────────────────────────────────────────────
    "blue": [
      "Blue shirts",
      "Blue printed shirts",
      "Blue striped shirts",
      "Blue check shirts",
      "Blue Oxford shirts",
      "Blue linen shirts",
      "Blue satin shirts",
      "Blue knit shirts",
      "Blue full sleeve shirts",
      "Blue half sleeve shirts"
    ],
    "urban blue": [
      "Urban blue shirts",
      "Urban blue printed shirts",
      "Urban blue cotton shirts",
      "Urban blue satin shirts",
      "Urban blue full sleeve shirts",
      "Urban blue regular fit shirts",
      "Urban blue abstract shirts",
      "Urban blue casual shirts",
      "Urban blue solid shirts",
      "Urban blue fabric shirts"
    ],
    "sky blue": [
      "Sky blue shirts",
      "Sky blue knit shirts",
      "Sky blue Oxford shirts",
      "Sky blue linen shirts",
      "Sky blue printed shirts",
      "Sky blue solid shirts",
      "Sky blue slim fit shirts",
      "Sky blue full sleeve shirts",
      "Sky blue regular fit shirts",
      "Sky blue cotton shirts"
    ],
    "powder blue": [
      "Powder blue shirts",
      "Powder blue knit shirts",
      "Powder blue striped shirts",
      "Powder blue cotton shirts",
      "Powder blue slim fit shirts",
      "Powder blue solid shirts",
      "Powder blue full sleeve shirts",
      "Powder blue regular fit shirts",
      "Powder blue casual shirts",
      "Powder blue fabric shirts"
    ],
    "ice blue": [
      "Ice blue shirts",
      "Ice blue linen shirts",
      "Ice blue pure linen shirts",
      "Ice blue solid shirts",
      "Ice blue full sleeve shirts",
      "Ice blue cotton shirts",
      "Ice blue regular fit shirts",
      "Ice blue casual shirts",
      "Ice blue European linen shirts",
      "Ice blue fabric shirts"
    ],
    "light blue": [
      "Light blue shirts",
      "Light blue linen shirts",
      "Light blue striped shirts",
      "Light blue solid shirts",
      "Light blue cotton linen shirts",
      "Light blue printed shirts",
      "Light blue full sleeve shirts",
      "Light blue half sleeve shirts",
      "Light blue regular fit shirts",
      "Light blue casual shirts"
    ],
    "slate blue": [
      "Slate blue shirts",
      "Slate blue satin shirts",
      "Slate blue solid shirts",
      "Slate blue stretch shirts",
      "Slate blue cotton shirts",
      "Slate blue full sleeve shirts",
      "Slate blue regular fit shirts",
      "Slate blue luxe shirts",
      "Slate blue party shirts",
      "Slate blue formal shirts"
    ],
    "navy": [
      "Navy shirts",
      "Navy linen shirts",
      "Navy printed shirts",
      "Navy leaf print shirts",
      "Navy Oxford shirts",
      "Navy textured shirts",
      "Navy Cuban collar shirts",
      "Navy solid shirts",
      "Navy full sleeve shirts",
      "Navy half sleeve shirts"
    ],
    "navy blue": [
      "Navy blue shirts",
      "Navy blue Oxford shirts",
      "Navy blue solid shirts",
      "Navy blue cotton shirts",
      "Navy blue full sleeve shirts",
      "Navy blue regular fit shirts",
      "Navy blue casual shirts",
      "Navy blue fabric shirts",
      "Navy blue formal shirts",
      "Navy blue button-down shirts"
    ],
    "navy grey": [
      "Navy grey shirts",
      "Navy grey striped shirts",
      "Navy grey Oxford shirts",
      "Navy grey cotton shirts",
      "Navy grey solid shirts",
      "Navy grey full sleeve shirts",
      "Navy grey regular fit shirts",
      "Navy grey casual shirts",
      "Navy grey fabric shirts",
      "Navy grey formal shirts"
    ],
    "navy gray": [
      "Navy grey shirts",
      "Navy grey striped shirts",
      "Navy grey Oxford shirts",
      "Navy grey cotton shirts",
      "Navy grey solid shirts",
      "Navy grey full sleeve shirts",
      "Navy grey regular fit shirts",
      "Navy grey casual shirts",
      "Navy grey fabric shirts",
      "Navy grey formal shirts"
    ],
    "blue grey": [
      "Blue grey shirts",
      "Blue grey crinkled shirts",
      "Blue grey solid shirts",
      "Blue grey viscose shirts",
      "Blue grey half sleeve shirts",
      "Blue grey regular fit shirts",
      "Blue grey textured shirts",
      "Blue grey casual shirts",
      "Blue grey fabric shirts",
      "Blue grey printed shirts"
    ],
    "blue gray": [
      "Blue grey shirts",
      "Blue grey crinkled shirts",
      "Blue grey solid shirts",
      "Blue grey viscose shirts",
      "Blue grey half sleeve shirts",
      "Blue grey regular fit shirts",
      "Blue grey textured shirts",
      "Blue grey casual shirts",
      "Blue grey fabric shirts",
      "Blue grey printed shirts"
    ],
    "metallic blue": [
      "Metallic blue shirts",
      "Metallic blue printed shirts",
      "Metallic blue abstract shirts",
      "Metallic blue satin shirts",
      "Metallic blue cotton shirts",
      "Metallic blue full sleeve shirts",
      "Metallic blue regular fit shirts",
      "Metallic blue party shirts",
      "Metallic blue casual shirts",
      "Metallic blue fabric shirts"
    ],

    // ── GREEN COLORS ──────────────────────────────────────────────────
    "green": [
      "Green shirts",
      "Green Oxford shirts",
      "Green linen shirts",
      "Green printed shirts",
      "Green floral shirts",
      "Green solid shirts",
      "Green cotton shirts",
      "Green full sleeve shirts",
      "Green half sleeve shirts",
      "Green regular fit shirts"
    ],
    "sage green": [
      "Sage green shirts",
      "Sage green Oxford shirts",
      "Sage green linen shirts",
      "Sage green satin shirts",
      "Sage green solid shirts",
      "Sage green stretch shirts",
      "Sage green cotton shirts",
      "Sage green full sleeve shirts",
      "Sage green half sleeve shirts",
      "Sage green regular fit shirts"
    ],
    "dark green": [
      "Dark green shirts",
      "Dark green Oxford shirts",
      "Dark green linen shirts",
      "Dark green pure linen shirts",
      "Dark green solid shirts",
      "Dark green cotton shirts",
      "Dark green full sleeve shirts",
      "Dark green regular fit shirts",
      "Dark green casual shirts",
      "Dark green fabric shirts"
    ],
    "olive": [
      "Olive shirts",
      "Olive printed shirts",
      "Olive Cuban collar shirts",
      "Olive cotton shirts",
      "Olive twill shirts",
      "Olive abstract shirts",
      "Olive half sleeve shirts",
      "Olive regular fit shirts",
      "Olive textured shirts",
      "Olive casual shirts"
    ],
    "mint green": [
      "Mint green shirts",
      "Mint green knit shirts",
      "Mint green cotton shirts",
      "Mint green slim fit shirts",
      "Mint green solid shirts",
      "Mint green half sleeve shirts",
      "Mint green stretch shirts",
      "Mint green regular fit shirts",
      "Mint green casual shirts",
      "Mint green fabric shirts"
    ],
    "light green": [
      "Light green shirts",
      "Light green striped shirts",
      "Light green linen shirts",
      "Light green cotton linen shirts",
      "Light green solid shirts",
      "Light green half sleeve shirts",
      "Light green regular fit shirts",
      "Light green casual shirts",
      "Light green fabric shirts",
      "Light green summer shirts"
    ],

    // ── PINK AND PURPLE COLORS ────────────────────────────────────────
    "pink": [
      "Pink shirts",
      "Pink Oxford shirts",
      "Pink linen shirts",
      "Pink pure linen shirts",
      "Pink printed shirts",
      "Pink solid shirts",
      "Pink full sleeve shirts",
      "Pink half sleeve shirts",
      "Pink regular fit shirts",
      "Pink casual shirts"
    ],
    "blossom pink": [
      "Blossom pink shirts",
      "Blossom pink knit shirts",
      "Blossom pink striped shirts",
      "Blossom pink cotton shirts",
      "Blossom pink slim fit shirts",
      "Blossom pink solid shirts",
      "Blossom pink full sleeve shirts",
      "Blossom pink stretch shirts",
      "Blossom pink regular fit shirts",
      "Blossom pink casual shirts"
    ],
    "dusty pink": [
      "Dusty pink shirts",
      "Dusty pink printed shirts",
      "Dusty pink linen shirts",
      "Dusty pink cotton linen shirts",
      "Dusty pink solid shirts",
      "Dusty pink full sleeve shirts",
      "Dusty pink half sleeve shirts",
      "Dusty pink regular fit shirts",
      "Dusty pink casual shirts",
      "Dusty pink fabric shirts"
    ],
    "dawn pink": [
      "Dawn pink shirts",
      "Dawn pink linen shirts",
      "Dawn pink cotton linen shirts",
      "Dawn pink solid shirts",
      "Dawn pink full sleeve shirts",
      "Dawn pink cotton shirts",
      "Dawn pink regular fit shirts",
      "Dawn pink casual shirts",
      "Dawn pink fabric shirts",
      "Dawn pink summer shirts"
    ],
    "champagne pink": [
      "Champagne pink shirts",
      "Champagne pink crinkled shirts",
      "Champagne pink viscose shirts",
      "Champagne pink solid shirts",
      "Champagne pink half sleeve shirts",
      "Champagne pink regular fit shirts",
      "Champagne pink printed shirts",
      "Champagne pink fabric shirts",
      "Champagne pink casual shirts",
      "Champagne pink blend shirts"
    ],
    "peach": [
      "Peach shirts",
      "Peach TENCEL shirts",
      "Peach printed shirts",
      "Peach Cuban collar shirts",
      "Peach cotton shirts",
      "Peach half sleeve shirts",
      "Peach regular fit shirts",
      "Peach plain weave shirts",
      "Peach casual shirts",
      "Peach fabric shirts"
    ],
    "mauve": [
      "Mauve shirts",
      "Mauve knit shirts",
      "Mauve textured shirts",
      "Mauve cotton shirts",
      "Mauve slim fit shirts",
      "Mauve solid shirts",
      "Mauve full sleeve shirts",
      "Mauve stretch shirts",
      "Mauve regular fit shirts",
      "Mauve casual shirts"
    ],
    "dusty mauve": [
      "Dusty mauve shirts",
      "Dusty mauve lyocell shirts",
      "Dusty mauve linen shirts",
      "Dusty mauve lyocell linen shirts",
      "Dusty mauve solid shirts",
      "Dusty mauve full sleeve shirts",
      "Dusty mauve regular fit shirts",
      "Dusty mauve blend shirts",
      "Dusty mauve casual shirts",
      "Dusty mauve fabric shirts"
    ],
    "twilight mauve": [
      "Twilight mauve shirts",
      "Twilight mauve satin shirts",
      "Twilight mauve solid shirts",
      "Twilight mauve stretch shirts",
      "Twilight mauve cotton shirts",
      "Twilight mauve full sleeve shirts",
      "Twilight mauve regular fit shirts",
      "Twilight mauve luxe shirts",
      "Twilight mauve party shirts",
      "Twilight mauve formal shirts"
    ],
    "lavender": [
      "Lavender shirts",
      "Lavender Oxford shirts",
      "Lavender striped shirts",
      "Lavender solid shirts",
      "Lavender cotton shirts",
      "Lavender full sleeve shirts",
      "Lavender half sleeve shirts",
      "Lavender regular fit shirts",
      "Lavender casual shirts",
      "Lavender fabric shirts"
    ],
    "purple": [
      "Purple shirts",
      "Purple printed shirts",
      "Purple solid shirts",
      "Purple striped shirts",
      "Purple cotton shirts",
      "Purple linen shirts",
      "Purple satin shirts",
      "Purple full sleeve shirts",
      "Purple half sleeve shirts",
      "Purple regular fit shirts"
    ],

    // ── RED, ORANGE, YELLOW, AND METALLIC COLORS ──────────────────────
    "maroon": [
      "Maroon shirts",
      "Maroon printed shirts",
      "Maroon Cuban collar shirts",
      "Maroon linen shirts",
      "Maroon satin shirts",
      "Maroon solid shirts",
      "Maroon full sleeve shirts",
      "Maroon half sleeve shirts",
      "Maroon regular fit shirts",
      "Maroon cotton shirts"
    ],
    "light maroon": [
      "Light maroon shirts",
      "Light maroon satin shirts",
      "Light maroon solid shirts",
      "Light maroon stretch shirts",
      "Light maroon cotton shirts",
      "Light maroon full sleeve shirts",
      "Light maroon regular fit shirts",
      "Light maroon luxe shirts",
      "Light maroon party shirts",
      "Light maroon formal shirts"
    ],
    "burgundy": [
      "Burgundy shirts",
      "Burgundy printed shirts",
      "Burgundy bloom shirts",
      "Burgundy cotton shirts",
      "Burgundy slub shirts",
      "Burgundy half sleeve shirts",
      "Burgundy regular fit shirts",
      "Burgundy floral shirts",
      "Burgundy casual shirts",
      "Burgundy fabric shirts"
    ],
    "rust": [
      "Rust shirts",
      "Rust textured shirts",
      "Rust Cuban collar shirts",
      "Rust cotton shirts",
      "Rust printed shirts",
      "Rust half sleeve shirts",
      "Rust regular fit shirts",
      "Rust solid shirts",
      "Rust casual shirts",
      "Rust fabric shirts"
    ],
    "red": [
      "Red shirts",
      "Red printed shirts",
      "Red solid shirts",
      "Red cotton shirts",
      "Red linen shirts",
      "Red satin shirts",
      "Red full sleeve shirts",
      "Red half sleeve shirts",
      "Red regular fit shirts",
      "Red casual shirts"
    ],
    "orange": [
      "Orange shirts",
      "Orange linen shirts",
      "Orange cotton linen shirts",
      "Orange solid shirts",
      "Orange half sleeve shirts",
      "Orange regular fit shirts",
      "Orange cotton shirts",
      "Orange casual shirts",
      "Orange fabric shirts",
      "Orange summer shirts"
    ],
    "yellow": [
      "Yellow shirts",
      "Yellow linen shirts",
      "Yellow pure linen shirts",
      "Yellow solid shirts",
      "Yellow cotton shirts",
      "Yellow full sleeve shirts",
      "Yellow regular fit shirts",
      "Yellow casual shirts",
      "Yellow fabric shirts",
      "Yellow summer shirts"
    ],
    "butter yellow": [
      "Butter yellow shirts",
      "Butter yellow Oxford shirts",
      "Butter yellow cotton shirts",
      "Butter yellow solid shirts",
      "Butter yellow half sleeve shirts",
      "Butter yellow regular fit shirts",
      "Butter yellow full sleeve shirts",
      "Butter yellow casual shirts",
      "Butter yellow fabric shirts",
      "Butter yellow summer shirts"
    ],
    "gold": [
      "Gold shirts",
      "Gold printed shirts",
      "Gold solid shirts",
      "Gold satin shirts",
      "Gold cotton shirts",
      "Gold full sleeve shirts",
      "Gold half sleeve shirts",
      "Gold regular fit shirts",
      "Gold party shirts",
      "Gold casual shirts"
    ],
    "honey gold": [
      "Honey gold shirts",
      "Honey gold textured shirts",
      "Honey gold Cuban collar shirts",
      "Honey gold cotton shirts",
      "Honey gold printed shirts",
      "Honey gold half sleeve shirts",
      "Honey gold regular fit shirts",
      "Honey gold solid shirts",
      "Honey gold casual shirts",
      "Honey gold fabric shirts"
    ],
    "rose gold": [
      "Rose gold shirts",
      "Rose gold satin shirts",
      "Rose gold solid shirts",
      "Rose gold printed shirts",
      "Rose gold cotton shirts",
      "Rose gold full sleeve shirts",
      "Rose gold half sleeve shirts",
      "Rose gold regular fit shirts",
      "Rose gold party shirts",
      "Rose gold casual shirts"
    ],

    // ── GREY AND SILVER COLORS ────────────────────────────────────────
    "grey": [
      "Grey shirts",
      "Gray shirts",
      "Grey Oxford shirts",
      "Grey striped shirts",
      "Grey check shirts",
      "Grey linen shirts",
      "Grey solid shirts",
      "Grey cotton shirts",
      "Grey full sleeve shirts",
      "Grey regular fit shirts"
    ],
    "gray": [
      "Grey shirts",
      "Gray shirts",
      "Grey Oxford shirts",
      "Grey striped shirts",
      "Grey check shirts",
      "Grey linen shirts",
      "Grey solid shirts",
      "Grey cotton shirts",
      "Grey full sleeve shirts",
      "Grey regular fit shirts"
    ],
    "light grey": [
      "Light grey shirts",
      "Light grey Oxford shirts",
      "Light grey solid shirts",
      "Light grey cotton shirts",
      "Light grey half sleeve shirts",
      "Light grey regular fit shirts",
      "Light grey full sleeve shirts",
      "Light grey casual shirts",
      "Light grey fabric shirts",
      "Light grey formal shirts"
    ],
    "light gray": [
      "Light grey shirts",
      "Light grey Oxford shirts",
      "Light grey solid shirts",
      "Light grey cotton shirts",
      "Light grey half sleeve shirts",
      "Light grey regular fit shirts",
      "Light grey full sleeve shirts",
      "Light grey casual shirts",
      "Light grey fabric shirts",
      "Light grey formal shirts"
    ],
    "ash grey": [
      "Ash grey shirts",
      "Ash grey satin shirts",
      "Ash grey solid shirts",
      "Ash grey cotton shirts",
      "Ash grey stretch shirts",
      "Ash grey full sleeve shirts",
      "Ash grey regular fit shirts",
      "Ash grey luxe shirts",
      "Ash grey formal shirts",
      "Ash grey party shirts"
    ],
    "ash gray": [
      "Ash grey shirts",
      "Ash grey satin shirts",
      "Ash grey solid shirts",
      "Ash grey cotton shirts",
      "Ash grey stretch shirts",
      "Ash grey full sleeve shirts",
      "Ash grey regular fit shirts",
      "Ash grey luxe shirts",
      "Ash grey formal shirts",
      "Ash grey party shirts"
    ],
    "charcoal": [
      "Charcoal shirts",
      "Charcoal printed shirts",
      "Charcoal Cuban collar shirts",
      "Charcoal abstract shirts",
      "Charcoal cotton shirts",
      "Charcoal slub shirts",
      "Charcoal half sleeve shirts",
      "Charcoal regular fit shirts",
      "Charcoal textured shirts",
      "Charcoal casual shirts"
    ],
    "silver grey": [
      "Silver grey shirts",
      "Silver grey striped shirts",
      "Silver grey linen shirts",
      "Silver grey cotton linen shirts",
      "Silver grey solid shirts",
      "Silver grey half sleeve shirts",
      "Silver grey regular fit shirts",
      "Silver grey cotton shirts",
      "Silver grey casual shirts",
      "Silver grey fabric shirts"
    ],
    "silver gray": [
      "Silver grey shirts",
      "Silver grey striped shirts",
      "Silver grey linen shirts",
      "Silver grey cotton linen shirts",
      "Silver grey solid shirts",
      "Silver grey half sleeve shirts",
      "Silver grey regular fit shirts",
      "Silver grey cotton shirts",
      "Silver grey casual shirts",
      "Silver grey fabric shirts"
    ],
    "silver": [
      "Silver shirts",
      "Silver grey shirts",
      "Silver satin shirts",
      "Silver solid shirts",
      "Silver printed shirts",
      "Silver cotton shirts",
      "Silver full sleeve shirts",
      "Silver half sleeve shirts",
      "Silver regular fit shirts",
      "Silver party shirts"
    ]
  };

  window.SLAY_CUSTOM_SEARCH_MAP = dictionary;

  /**
   * Retrieves predictions for an input query with dynamic prefix matching.
   * Handles direct key matches, prefix matches, and terms followed by "shirt", "shirts", "shirtt", etc.
   * Runs in < 0.1ms with 0 network overhead.
   */
  window.getCustomSearchPredictions = function(inputQuery) {
    if (!inputQuery || !dictionary) return null;
    var term = inputQuery.trim().toLowerCase();
    if (term.length < 2) return null;

    function getMatches(searchTerm) {
      // 1. Direct exact match
      if (dictionary[searchTerm]) {
        return dictionary[searchTerm].slice(0, 6);
      }

      var keys = Object.keys(dictionary);

      // 2. Direct prefix match on key (e.g. "bl" -> "black", "blu" -> "blue", "san" -> "sand beige")
      var prefixMatches = keys.filter(function(key) {
        return key.startsWith(searchTerm);
      });

      if (prefixMatches.length > 0) {
        prefixMatches.sort(function(a, b) {
          return a.length - b.length;
        });
        var results = [];
        var seen = {};
        prefixMatches.forEach(function(key) {
          var items = dictionary[key];
          items.forEach(function(item) {
            var lower = item.toLowerCase();
            if (!seen[lower]) {
              seen[lower] = true;
              results.push(item);
            }
          });
        });
        return results.slice(0, 6);
      }

      // 3. Fallback word prefix match (e.g. "gre" matches "sage green", "light green")
      var wordMatches = keys.filter(function(key) {
        var words = key.split(/\s+/);
        return words.some(function(w) { return w.startsWith(searchTerm); });
      });

      if (wordMatches.length > 0) {
        wordMatches.sort(function(a, b) {
          return a.length - b.length;
        });
        var results = [];
        var seen = {};
        wordMatches.forEach(function(key) {
          var items = dictionary[key];
          items.forEach(function(item) {
            var lower = item.toLowerCase();
            if (!seen[lower]) {
              seen[lower] = true;
              results.push(item);
            }
          });
        });
        return results.slice(0, 6);
      }

      return null;
    }

    // Direct match / prefix match on raw term first
    var directResults = getMatches(term);
    if (directResults && directResults.length > 0) {
      return directResults;
    }

    // If query ends with "shirt", "shirts", "shirtt", "shrt", "shrts", "shits", "sh", "shi", etc.
    // Strip trailing shirt variation/partial suffix and match against the base term
    var baseTerm = term.replace(/\s+(shirts?|shirtts?|shrts?|shits?|sh|shi|shir)$/i, '').trim();
    if (baseTerm && baseTerm !== term && baseTerm.length >= 2) {
      var baseResults = getMatches(baseTerm);
      if (baseResults && baseResults.length > 0) {
        return baseResults;
      }
    }

    return null;
  };
})();
